import React from 'react';
import { DocumentGroup } from 'src/components/Documents/DocumentGroup';
import { groupDocuments as groupDocumentsUtil } from 'src/components/Documents/DocumentGrouping';

interface GroupedDocumentsListProps {
  documents: any[];
  user: any;
  onDownload: (url: string) => void;
  onDeleteDocument: (document: any) => void;
  onClick: (index: number, url: string, isImage: boolean) => void;
  useCustomConfirmation?: boolean;
}

const GroupedDocumentsList = ({
  documents,
  user,
  onDownload,
  onDeleteDocument,
  onClick,
  useCustomConfirmation,
}: GroupedDocumentsListProps) => {
  const { priority, General, ...customGroups } = groupDocumentsUtil(documents);

  const sharedGroupProps = {
    user,
    onDownload,
    onDeleteDocument,
    onClick,
    from: undefined,
    useCustomConfirmation,
  };

  return (
    <>
      {priority.length > 0 && (
        <DocumentGroup
          name="Priority"
          documents={priority}
          defaultExpanded
          {...sharedGroupProps}
        />
      )}

      {Object.keys(customGroups).map((group: string) => {
        if (customGroups[group].length === 0) {
          return null;
        }

        return (
          <DocumentGroup
            key={group}
            name={group}
            documents={customGroups[group]}
            {...sharedGroupProps}
          />
        );
      })}
      {General.length > 0 && (
        <DocumentGroup
          name="Manuals & Documents "
          documents={General}
          {...sharedGroupProps}
        />
      )}
    </>
  );
};

export default GroupedDocumentsList;
